import ColorInput from 'components/ColorInput/ColorInput'
import { cloneDeep, set } from 'lodash'
import { useRef } from 'react'
import Dropdown from 'components/Dropdown/Dropdown'
import particleSystems from '../../../config/particleSystems'

const DesignTab = ({
  values,
  onChange,
  onSubmit,
  mixedValues,
  onMixedValuesChange,
  colorsOnly,
}) => {
  const containerRef = useRef()
  const { highlightColor, bgColor, fgColor, visualizer, particleSystem } =
    values?.data?.theme || {}
  const { type: particleSystemType } = particleSystem || {}

  const visualizerDescription = visualizerOptions.find(
    (op) => op.id === visualizer,
  )?.description

  function handleThemeChange(name, value) {
    const newValues = cloneDeep(values)
    newValues.data.theme[name] = value
    onChange(newValues)
  }

  function handleVisualizerChange(value) {
    const newValues = cloneDeep(values)
    newValues.data.theme.particleSystem = {
      type: value,
    }
    onChange(newValues)
  }

  function handleUnlock(field) {
    const values = cloneDeep(mixedValues)
    set(values, `data.theme.${field}`, false)
    onMixedValuesChange(values)
  }

  return (
    <div className="h-full w-full" ref={containerRef}>
      <h3 className="mb-2">Theme</h3>
      <div className="flex">
        <div className="w-full max-w-[200px]">
          <ColorInput
            label="Primary Color"
            value={highlightColor}
            containerRef={containerRef}
            onChange={(value) => handleThemeChange('highlightColor', value)}
            isLocked={mixedValues?.data?.theme?.highlightColor}
            onUnlock={() => handleUnlock('highlightColor')}
          />
        </div>
        <div className="w-full max-w-[200px] ml-10">
          <ColorInput
            label="Mouse Over Color"
            value={fgColor}
            containerRef={containerRef}
            onChange={(value) => handleThemeChange('fgColor', value)}
            isLocked={mixedValues?.data?.theme?.fgColor}
            onUnlock={() => handleUnlock('fgColor')}
          />
        </div>
        <div className="w-full max-w-[200px] ml-10">
          <ColorInput
            label="Background Color"
            value={bgColor}
            containerRef={containerRef}
            onChange={(value) => handleThemeChange('bgColor', value)}
            isLocked={mixedValues?.data?.theme?.bgColor}
            onUnlock={() => handleUnlock('bgColor')}
          />
        </div>
      </div>
      <h3 className="mt-10 mb-2">Visualizer</h3>
      <div>
        <div className="w-1/3">
          <Dropdown
            label="Style"
            options={visualizerOptions}
            value={visualizer}
            onChange={(value) => handleThemeChange('visualizer', value)}
            isLocked={mixedValues?.data?.theme?.visualizer}
            onUnlock={() => handleUnlock('visualizer')}
          ></Dropdown>
        </div>
        {visualizerDescription && (
          <div className="mt-2 text-white-dark">{visualizerDescription}</div>
        )}
      </div>

      <h3 className="mt-10 mb-2">Particles</h3>
      <div>
        <div className="w-1/3">
          <Dropdown
            label="Particle System"
            options={particleOptions}
            value={particleSystemType || ''}
            onChange={handleVisualizerChange}
            isLocked={mixedValues?.data?.theme?.particleSystem?.type}
            onUnlock={() => handleUnlock('particleSystem.type')}
          ></Dropdown>
        </div>
      </div>
      <button
        className="button bg-pink mt-6 mb-6"
        onClick={() => onSubmit(values)}
      >
        Save
      </button>
    </div>
  )
}

const visualizerOptions = [
  {
    id: 'disabled',
    name: 'Disabled',
    description: 'The waveform will be static with no visualizer.',
  },
  {
    id: 'default',
    name: 'Balanced',
    description: 'A balanced visualizer which should work for most tracks.',
  },
  {
    id: 'orchestral',
    name: 'Orchestral',
    description:
      'A smaller base waveform with a bigger focus on the frequency response',
  },
  {
    id: 'bass',
    name: 'Bass',
    description:
      'A smaller base waveform and frequency response with a big response to the 55-65hz range.',
  },
]

const particleOptions = [
  {
    id: '',
    name: 'None',
  },
  ...particleSystems,
]

export default DesignTab
